// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__S5Afy","loader":"loader_loader__PVguG"};